import './styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import SceneViewport from '../../../SceneViewport';
import ScansPanel from './ScansPanel';
import TipsPanel from '../TipsPanel';
import useViewerSceneState from './useViewerSceneState';
import ViewerBottomDock from './ViewerBottomDock';

function Renders({
    resourceScopeId,
    scans,
    showTips,
    setShowTips,
}) {
    const {
        bottomDockState,
        sceneEmptyState,
        sceneViewportProps,
        scansPanelState,
        tipsState,
    } = useViewerSceneState({
        resourceScopeId,
        scans,
        setShowTips,
        showTips,
    });

    return (
        <div className="render-viewport">
            <div className="render-engine-wrapper">
                <SceneViewport {...sceneViewportProps} />
            </div>
            {sceneEmptyState ? (
                <div className="render-empty-state" role="status" aria-live="polite">
                    <div className="render-empty-state-card">
                        <h3>{sceneEmptyState.title}</h3>
                        <p>{sceneEmptyState.body}</p>
                    </div>
                </div>
            ) : (
                <>
                    <ScansPanel panel={scansPanelState} />
                    <ViewerBottomDock dock={bottomDockState} />
                    <TipsPanel tips={tipsState} />
                </>
            )}
        </div>
    );
}

Renders.propTypes = {
    showTips: PropTypes.bool.isRequired,
    setShowTips: PropTypes.func.isRequired,
    resourceScopeId: PropTypes.string,
    scans: PropTypes.arrayOf(
        PropTypes.shape({
            alternateName: PropTypes.string,
            correctedOrder: PropTypes.number,
            defaultVisible: PropTypes.bool,
            dentalCaseId: PropTypes.string,
            displayIndex: PropTypes.number,
            displayLabel: PropTypes.string,
            id: PropTypes.string,
            label: PropTypes.string,
            plyUrl: PropTypes.string,
            preservePlacement: PropTypes.bool,
            stlUrl: PropTypes.string,
            textureUrl: PropTypes.string,
        }),
    ).isRequired,
};

Renders.defaultProps = {
    resourceScopeId: null,
};

export default Renders;
